import React from 'react';
import { Field } from 'react-form';
import ReactSelect from 'react-select';
import PropTypes, { any } from 'prop-types';

import InfoButton from '../../InfoButton';
import Option from './CustomizeOption';

import styles from './DefaultSelect.scss';

const customizeStyles = {
    control: base => ({
        ...base,
        border: '1px solid grey',
        boxShadow: 'none',
        '&:hover': {
            border: '1px solid grey',
        },
        paddingTop: 0,
        paddingBottom: 0,
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
        boxShadow: 'none',
        borderTop: 'none',
    }),
    option: (styles, { isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? 'e0e1e2' : '',
            color: 'black',
            display: 'flex',
            paddingLeft: '12px',
            fontSize: '14px',
            border: '1px solid grey',
            fontWeight: 'normal',
        };
    },

};

const DefaultSelect = (props) => {
    return (
        <Field field={props.field} validate={props.validate}>
            {fieldApi => {
                const { onChange, onBlur, id, label, options, description, hiddenLabel, hoverText, emptyOption, formGroupCssClass, themeV3 } = props;
                const { value, error, warning, touched, setValue, setTouched } = fieldApi;

                const handleChangeEvent = (option) => {
                    const { value } = option;
                    setTouched();
                    setValue(value);
                    if (onChange) {
                        onChange(value);
                    }
                };

                const isError = touched && error;

                const errorClassName = isError ? `${styles.isInvalid} is-invalid` : '';

                return (
                    <div className={`form-group form-group-xl ${styles.formSelect} ${formGroupCssClass} ${errorClassName} ${description ? 'description' : ''} ${themeV3 ? styles.themeV3 : ''}`}>
                        <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                            {!themeV3 && label}
                            {hoverText && <InfoButton hoverText={hoverText} />}
                        </label>
                        {description && (<small>{description}</small>)}
                        <ReactSelect
                            id={id}
                            value={value ? options.find(option => option.value === value) : ''}
                            placeholder={emptyOption}
                            options={options}
                            components={{ Option }}
                            onChange={(option) => handleChangeEvent(option)}
                            onBlur={e => {
                                setTouched();
                                if (onBlur) {
                                    onBlur(e);
                                }
                            }}
                            styles={customizeStyles}
                            className="react-select-container"
                            classNamePrefix="react-select"
                        />
                        {touched &&
                            ((error && <div className="invalid-feedback">{error}</div>) ||
                                (warning && <div className="warning-feedback">{warning}</div>))}
                    </div>
                );
            }}

        </Field>
    );
};

DefaultSelect.propTypes = {
    field: PropTypes.string.isRequired,
    validate: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(any).isRequired,
    description: PropTypes.string,
    hiddenLabel: PropTypes.bool,
    hoverText: PropTypes.string,
    emptyOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    formGroupCssClass: PropTypes.string,
    themeV3: PropTypes.bool,
};

DefaultSelect.defaultProps = {
    validate: () => {},
    onChange: () => {},
    onBlur: () => {},
    label: '',
    description: '',
    hiddenLabel: false,
    hoverText: '',
    emptyOption: true,
    formGroupCssClass: '',
    themeV3: true,
};

export default DefaultSelect;
